import Table from 'components/common/Table'
import React, { useContext, useEffect, useState } from 'react'
import { Roles } from 'utils/enums'
import TableButton from 'components/common/Buttons/TableButton'
import { UpdateFormContainer } from 'components/admin/Forms/UpdateFormContainer'
import { AdminDataContext } from 'context/AdminDataContext'
import QRCode from 'react-qr-code'
import * as QRAsImage from 'qrcode'
import { ToggleButton, ToggleButtonGroup } from '@mui/material'
import { getQrLoginUrl, QR_COUNTRIES } from 'helpers/qrCountry'
import CallsTable from '../Calls'
import PrintAccountsTable from './PrintAccountsTable'

const AccountsSection = ({
  ownerId,
  title,
  endpoint,
  getColumnForDeleting,
  disableAutoScroll,
}) => {
  const { accounts } = useContext(AdminDataContext)

  const [accountToModify, setAccountToModify] = useState(null)
  const [selectedAccount, setSelectedAccount] = useState(null)
  const [qrCountry, setQrCountry] = useState(QR_COUNTRIES.ARGENTINA)

  const buildQrUrl = (code) => getQrLoginUrl({
    appDomain: process.env.REACT_APP_APP_DOMAIN,
    code,
    country: qrCountry,
  })

  const aditionalColumns = [
    {
      Header: 'Llamadas',
      Cell: ({
        row: {
          original: {
            id, firstName, lastName, calls,
          },
        },
        cellCustomData,
      }) => (
        <TableButton
          selected={id === cellCustomData.selectedAccount?.id}
          clickHandler={() =>
            setSelectedAccount((ps) =>
              ps?.id === id
                ? null
                : {
                  title: `${firstName} ${lastName}`,
                  endpoint: calls,
                  id,
                })}
        >
          Ver Llamadas
        </TableButton>
      ),
    },
    {
      Header: 'QR',
      Cell: ({
        row: {
          original,
        },
        cellCustomData,
      }) => {
        return (original.code
          && (
          <QRCode
            value={getQrLoginUrl({
              appDomain: process.env.REACT_APP_APP_DOMAIN,
              code: original.code,
              country: cellCustomData.qrCountry,
            })}
            size={256}
          />
          ))
      },
    },
    {
      Header: 'Editar',
      Cell: ({ row: { original }, cellCustomData }) => (
        <TableButton
          selected={cellCustomData.accountToModify?.id === original?.id}
          clickHandler={() =>
            setAccountToModify((ps) =>
              ps?.id === original.id ? null : original)}
        >
          Editar
        </TableButton>
      ),
    },
    getColumnForDeleting(Roles.Account.mainPath),
  ]

  useEffect(() => {
    setSelectedAccount(null)
  }, [endpoint])

  return (
    <>
      <ToggleButtonGroup
        exclusive
        value={qrCountry}
        onChange={(_event, value) => value && setQrCountry(value)}
        aria-label='País del código QR'
        size='small'
      >
        <ToggleButton value={QR_COUNTRIES.ARGENTINA}>Argentina</ToggleButton>
        <ToggleButton value={QR_COUNTRIES.CHILE}>Chile</ToggleButton>
      </ToggleButtonGroup>
      <PrintAccountsTable
        data={ownerId ? accounts.filter((c) => c.clientId === ownerId) : accounts}
        filename={qrCountry === QR_COUNTRIES.CHILE ? 'QR-Chile.docx' : 'QR.docx'}
        columns={[
          { Header: 'Email', accessor: 'email' },
          { Header: 'Nombre', accessor: (row) => `${row.firstName} ${row.lastName}` },
          {
            Header: 'QR',
            accessor: async (row) => {
              const url = buildQrUrl(row.code)
              const qrDataUrl = await QRAsImage.toDataURL(url)
              return {
                type: 'image',
                data: qrDataUrl,
              }
            },
          },

        ]}/>
      <Table
        key={ownerId || endpoint}
        endpoint={endpoint}
        tableData={
          ownerId ? accounts.filter((c) => c.clientId === ownerId) : accounts
        }
        title={title}
        aditionalColumns={aditionalColumns}
        searchOptions={ACCOUNT_SEARCH_OPTIONS}
        orderOptions={ACCOUNT_ORDER_OPTIONS}
        cellCustomData={{ accountToModify, selectedAccount, qrCountry }}
        disableAutoScroll={disableAutoScroll}
      >
        {selectedAccount && (
          <CallsTable
            endpoint={selectedAccount.endpoint}
            title={`Llamadas de ${selectedAccount.title}`}
            columnsToSkip={CALLS_COLUMNS_TO_SKIP}
          />
        )}
      </Table>
      {accountToModify && (
        <UpdateFormContainer
          roleObject={Roles.Account}
          initialValues={accountToModify}
          setSelectedUser={setAccountToModify}
        />
      )}
    </>
  )
}
const ACCOUNT_SEARCH_OPTIONS = ['email', 'firstName', 'lastName']
const ACCOUNT_ORDER_OPTIONS = ['email', 'firstName', 'lastName']
const CALLS_COLUMNS_TO_SKIP = ['accountFullName', 'accountEmail']

export default AccountsSection
